import { IconButton, makeStyles, Tooltip } from "@material-ui/core"
import CheckIcon from "@mui/icons-material/Check"
import EditIcon from "@mui/icons-material/Edit"
import { FormControlLabel, Switch } from "@mui/material"
import Toolbar from "@mui/material/Toolbar"
import React from "react"
import { useMediaQuery } from "react-responsive"
import CustomTableFilters from "../../Common/Table/CustomTableFilters"
import AddWidgetModal from "./addWidgetModal"

const useStyles = makeStyles({
  spacing: {
    marginRight: "10px",
  },
})

export default function DashboardToolbar(props) {
  const {
    filterManager,
    data,
    setFilteredData,
    showArchived,
    setShowArchived,
    edit,
    setEdit,
    saveAction,
    addAction,
  } = props

  const isMobile = useMediaQuery({ query: "(max-width: 625px)" })

  const classes = useStyles()

  const handleArchivedToggle = () => {
    setShowArchived(!showArchived)
  }

  const handleSave = async () => {
    await saveAction()
    setEdit(false)
  }

  const handleEdit = () => {
    setEdit(true)
  }

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <CustomTableFilters
        filterManager={filterManager}
        data={data}
        setFilteredData={setFilteredData}
        showArchived={showArchived}
      />
      <div className={classes.spacing} />
      {!isMobile &&
        (edit ? (
          <>
            <Tooltip title="Save Dashboard">
              <IconButton onClick={handleSave}>
                <CheckIcon />
              </IconButton>
            </Tooltip>
            <AddWidgetModal addAction={addAction} />
          </>
        ) : (
          <Tooltip title="Edit Dashboard">
            <IconButton onClick={handleEdit}>
              <EditIcon />
            </IconButton>
          </Tooltip>
        ))}

      <div className={classes.spacing} />
      <div style={{ flex: 1 }} />
      {!isMobile ? (
        <FormControlLabel
          checked={showArchived}
          onChange={handleArchivedToggle}
          control={<Switch />}
          label="Show archived"
        />
      ) : null}
    </Toolbar>
  )
}
